import React from 'react'
import cx from 'classnames'
import Images from '/data/images'
import DottedLine from '/img/svg/dotted-line'
import Image from './contentParticles/image'

import PeopleHero from '../../../../img/2020-img/people-hero.jpg'
import EnvironmentHero from '../../../../img/2020-img/environment-hero.jpg'
import InnovationHero from '../../../../img/2020-img/innovation-hero.jpg'
import FoundationalHero from '../../../../img/2020-img/foundational-hero.jpg'
import OverviewHero from '../../../../img/2020-img/overview-hero.jpg'
import CovidHero from '../../../../img/2020-img/covid-hero.jpg'

class Hero extends React.Component {
  renderImage() {
    const { image } = this.props.graphic

    return (
      <figure className="md:w-1/3 rounded-tr rounded-bl overflow-hidden relative max-w-372 mx-auto">
        <img
          className="w-full"
          data-label="image"
          alt=""
          src={Images[image.key].defaultRes}
          srcSet={`${Images[image.key].defaultRes} 1x, ${
            Images[image.key].hiRes
          } 2x`}
        />
        <figcaption className="bg-jet-black text-white text-center text-14 py-15 px-30 absolute bottom-0 w-full">
          {image.description}
        </figcaption>
      </figure>
    )
  }

  renderIcon() {
    const { icon } = this.props.graphic

    return (
      <div
        className="md:w-1/3 flex justify-center max-w-120 md:max-w-full mx-auto"
        dangerouslySetInnerHTML={{ __html: icon }}
      ></div>
    )
  }

  renderGraphic() {
    const { graphic } = this.props

    if (!graphic) {
      return null
    }

    if ('image' in graphic) {
      return this.renderImage()
    }

    if ('icon' in graphic) {
      return this.renderIcon()
    }
  }

  render() {
    const { hero, theme, graphic } = this.props

    let bgImage = null

    if (hero.key === 'people') {
      bgImage = PeopleHero
    }

    if (hero.key === 'environment') {
      bgImage = EnvironmentHero
    }

    if (hero.key === 'innovation') {
      bgImage = InnovationHero
    }

    if (hero.key === 'foundational') {
      bgImage = FoundationalHero
    }

    if (hero.key === 'overview') {
      bgImage = OverviewHero
    }

    if (hero.key === 'covid') {
      bgImage = CovidHero
    }

    return (
      <>
        <section
          data-label="hero"
          className="bg-white"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: bgImage === OverviewHero ? 'bottom center' : 'top center'
          }}
        >
          <div className="container px-25">
            <div
              data-label="hero-container"
              className={cx(
                'flex flex-col md:flex-row py-55 md:pt-90 md:pb-75 relative',
                {
                  'md:min-h-625 items-end': bgImage,
                }
              )}
            >
              <div className="text-center md:text-left md:w-2/3 mb-45 md:mb-0">
                {hero.title && (
                  <h1
                    data-label="hero-title"
                    className={cx(
                      `uppercase text-18 md:text-24 tracking-wide mb-15 font-condensed`,
                      {
                        [theme.textColor]: !bgImage,
                        'text-white': bgImage,
                      }
                    )}
                  >
                    {hero.title}
                  </h1>
                )}
                {hero.subtitle && (
                  <p
                    data-label="hero-subtitle"
                    className={cx(
                      'font-serif text-36 md:text-64 tracking-tight leading-tight',
                      {
                        'text-white': bgImage,
                      }
                    )}
                  >
                    {hero.subtitle}
                  </p>
                )}
              </div>
              {!bgImage && !graphic.after && this.renderGraphic()}
            </div>
            {!bgImage && <DottedLine className="max-h-3" />}

            {graphic.after && (
              <figure className="pt-30">
                <img
                  className="w-full"
                  data-label="image"
                  alt=""
                  src={Images[graphic.image.key].defaultRes}
                  srcSet={`${Images[graphic.image.key].defaultRes} 1x, ${
                    Images[graphic.image.key].hiRes
                  } 2x`}
                />
              </figure>
            )}

            {hero.heroImage &&
              <div className="mt-40">
                <Image images={hero.heroImage}/>
              </div>
            }
          </div>
        </section>
        {hero.caption && (
          <div className="container px-25">
            <p
              className="text-12 text-granite-gray pt-5"
              dangerouslySetInnerHTML={{ __html: hero.caption }}
            />
          </div>
        )}
      </>
    )
  }
}

export default Hero
